import { render, staticRenderFns } from "./EditorNavigation.vue?vue&type=template&id=0020d372&scoped=true&"
import script from "./EditorNavigation.vue?vue&type=script&lang=js&"
export * from "./EditorNavigation.vue?vue&type=script&lang=js&"
import style0 from "./EditorNavigation.vue?vue&type=style&index=0&id=0020d372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020d372",
  null
  
)

export default component.exports